/* Publish by EComposer at 2026-10-13 12:53:21*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-srdvsih1jo8"]=  window.__ectimmers["ecom-srdvsih1jo8"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-srdvsih1jo8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-srdvsih1jo8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rij1b0qmgl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rij1b0qmgl9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ahds1my7g9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ahds1my7g9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4vi4hsqzko').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4vi4hsqzko', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hb3jivsrug7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hb3jivsrug7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmew89tavs4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmew89tavs4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-110kg26ywyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-110kg26ywyh', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-f1asyr5egcf"]=  window.__ectimmers["ecom-f1asyr5egcf"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-f1asyr5egcf"]["08njwd7ru"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-f1asyr5egcf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f1asyr5egcf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kb2t2u8rovk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kb2t2u8rovk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0ffhptg6rmk5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0ffhptg6rmk5', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n0lyoeya6m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n0lyoeya6m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uht8bphei2p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uht8bphei2p', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-02ehqdtorjc3"]=  window.__ectimmers["ecom-02ehqdtorjc3"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-02ehqdtorjc3"]["7nr6q8g0n"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-02ehqdtorjc3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-02ehqdtorjc3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pku284x2uoc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pku284x2uoc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-769weiy34v9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-769weiy34v9', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-heqqd78ivl5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-heqqd78ivl5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xr41ix993x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xr41ix993x', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2oabvszxd7k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2oabvszxd7k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uoycgbvh74q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uoycgbvh74q', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-la79c2r5cgb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-la79c2r5cgb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}